import { ROUTES } from '@routes'

export const hotelTapeChartPath = [ROUTES.hotelTapeChart.path]

export const HOTEL_ID_STORAGE_KEY = 'hotelTapeChartHotelKey'

export const DEFAULT_HOTEL_ID = localStorage.getItem(HOTEL_ID_STORAGE_KEY)

export enum UnitsSorting {
  RANK = 'rank',
  UNIT_NUMBER = 'unit-number',
}

export enum UnassignedBookingsView {
  Disabled = 'disabled',
  List = 'list',
  Overlay = 'overlay',
  ListAndOverlay = 'listAndOverlay',
}